// extracted by mini-css-extract-plugin
export default {"resetButtoncss":"adminfaq_resetButtoncss__qQfRf","sticky":"adminfaq_sticky__l4750","table-container":"adminfaq_table-container__RLuZ0","faqTable":"adminfaq_faqTable__Tt-cu"};